<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-row align="start" justify="center" class="px-12">
      <v-col cols="12">
        <v-card class="elevation-5">
          <v-data-table
            :headers="headers"
            :items="tags"
            sort-by="workerleavetypeId"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading... Please wait"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Worker Leave Type</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on"
                      >New Leave Type</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.workerleavetypename"
                              label="Worker Leave Type Name"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              type="number"
                              v-model="editedItem.workerleavecount"
                              label="Worker Leave Count"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-select
                              v-model="editedItem.workerleavesystemcount"
                              :items="system_count"
                              label="Leave System Count"
                              item-text="name"
                              item-value="value"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.workerleavetypeId"
                              label="Worker Leave Type Id"
                              v-if="!hide"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="save"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
              <v-icon small @click="deleteItem(item)">delete</v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'

export default {
  name: 'worker_leave_type',
  data: () => ({
    search: '',
    dialog: false,
    loading: true,
    hide: true,
    system_count: [
      { name: 'Does Not Include', value: 0 },
      { name: 'Include', value: 1 }
    ],
    headers: [
      { text: 'WORKER LEAVE TYPE ID', value: 'workerleavetypeId' },
      { text: 'WORKER LEAVE TYPE NAME', value: 'workerleavetypename' },
      { text: 'WORKER LEAVE (DAYS)', value: 'workerleavecount' },
      { text: 'WORKER LEAVE SYSTEM COUNT', value: 'workerleavesystemcount' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    tags: [],
    editedIndex: -1,
    editedItem: {
      workerleavetypeId: 0,
      workerleavetypename: '',
      workerleavecount: 0,
      workerleavesystemcount: 0
    },
    defaultItem: {
      workerleavetypename: '',
      workerleavecount: 0,
      workerleavesystemcount: 0
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.submitBtnLoading = true
      ApiService.get('/WorkerLeaveType')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.tags = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    editItem(item) {
      this.editedIndex = this.tags.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.tags.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.tags.splice(index, 1)
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        let workerleavetypename = this.editedItem.workerleavetypename
        let workerleavetypeId = this.tags[this.editedIndex].workerleavetypeId
        let workerleavecount = this.editedItem.workerleavecount
        let workerleavesystemcount = this.editedItem.workerleavesystemcount
        let parent = this
        ApiService.put('/WorkerLeaveType/' + workerleavetypeId, {
          workerleavetypename,
          workerleavecount,
          workerleavesystemcount
        }).then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {
              parent.initialize()
              parent.btnLoading = false
            })
          } else {
            this.btnLoading = false
            this.$swal('', res.data.error, 'error')
          }
        })
      } else {
        let workerleavetypename = this.editedItem.workerleavetypename
        let workerleavecount = this.editedItem.workerleavecount
        let workerleavesystemcount = this.editedItem.workerleavesystemcount
        let parent = this
        ApiService.post('/WorkerLeaveType', {
          workerleavetypename,
          workerleavecount,
          workerleavesystemcount
        }).then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {
              parent.initialize()
              parent.btnLoading = false
            })
          } else {
            this.btnLoading = false
            this.$swal('', res.data.error, 'error')
          }
        })
      }
      this.close()
    }
  }
}
</script>
